<template>
    <!-- 待支付 -->
    <div id="paypage">
        <el-card class="details_box-card" shadow="never">
            <div slot="header" class="clearfix">
                <div class="descicon"></div>待支付详情
            </div>
            <div class="payPageDetail">
                <div>预约单原价</div>
                <div>¥{{payInfo.originalPrice || '0.00'}}</div>
            </div>
            <hr class="dashedHr" />
            <div class="payPageDetail" v-if="payInfo.ifUrgent == 1">
                <div>加急制作</div>
                <div>¥{{payInfo.expeditedProduction || '0.00'}}</div>
            </div>
            <hr class="dashedHr" v-if="payInfo.ifUrgent == 1" />
            <div class="payPageDetail" v-if="payInfo.ifRecycle == 1">
                <div>样品回收</div>
                <div v-if="this.$store.getters.userInfo.whiteFlag == 0 || (this.$store.getters.userInfo.whiteFlag == 1 && this.$store.getters.userInfo.recoveryFree == 0)">
                    <span v-if="payInfo.addressId == 298">¥12</span>
                    <span v-else>¥50</span>
                </div>
                <div v-else>客户优惠</div>
            </div>
            <hr class="dashedHr" v-if="payInfo.ifRecycle == 1" />
            <div class="payPageDetail" v-if="payInfo.postPayment == 1 && payInfo.postMethod == 1">
                <div>到付运费</div>
                <div>¥12</div>
            </div>
            <hr class="dashedHr" v-if="payInfo.postPayment == 1 && payInfo.postMethod == 1" />
            <div class="payPageDetail" v-if="!isTeamShop">
                <div>订单折扣</div>
                <div class="zhekouClass">
                    <div >
                    <el-radio-group v-model="payInfo.discountType" @change="changeDiscount">
                        <el-radio disabled :label="1">
                            <span class="voucherName">个人折扣</span>
                        </el-radio>
                        <el-radio disabled :label="2">
                            <span class="voucherName">团队折扣</span>
                        </el-radio>
                    </el-radio-group>
                    <div class="tipsWord" >使用团队折扣则仅能使用团队信用或团队预存支付,使用个人折扣则不能使用团队信用或团队预存支付</div>
                    </div>
                    <div style="width: 80px;text-align: right;" >-¥{{payInfo.discountMoney || '0.00'}}</div>
                </div>
            </div>
            <hr class="dashedHr" v-if="!isTeamShop"/>
            <div class="payPageDetail" v-if="!isTeamShop">
                <div>可用优惠券</div>
                <div>-¥{{payInfo.couponMoney || '0.00'}}</div>
            </div>
            <div class="couponList" v-if="!isTeamShop">
                <div class="emptycoupon" v-if="couponList.length == 0">暂无可用优惠券</div>
                <!-- <el-empty description="暂无可用优惠券" v-if="couponList.length == 0"></el-empty> -->
                <el-row :gutter="50" type="flex" style="flex-wrap: wrap;" v-else>
                    <el-col v-show="showCoupon(coupon.paymentType)" v-for="(coupon,index) in couponList" :key="coupon+index" :sm="24" :md="12" :lg="12" :xl="8">
                        <div class="coupon_box">
                            <el-checkbox :style="{left: '-25px',top: '40px'}" class="desc-check" @change="changeCheck(coupon,index)" v-model="coupon.checked"></el-checkbox>
                            <div class="coupon_box_content">
                                <div class="coupon_amount">
                                    <span class="couponAmount" v-if="coupon.couponMode == 1">¥ {{ coupon.deductionAmount }}</span>
                                    <span class="couponAmount" v-if="coupon.couponMode == 2">{{ coupon.couponRate / 10 }} 折</span>
                                    <div class="serviceThreshold">满¥{{coupon.serviceThreshold}}可用</div>
                                </div>
                                <div class="pay_coupon_name">
                                    <div class="couponName-left">
                                        <el-tag type="warning" effect="dark" v-if="coupon.num> 1">{{coupon.num}}张</el-tag>
                                        <div class="couponName">{{coupon.couponName}}</div>
                                    </div>
                                    <div class="couponTime" v-if="coupon.validEndDate == '永久有效'">永久有效</div>
                                    <div class="couponTime" v-else>{{$moment(coupon.validStartDate).format("YYYY.MM.DD")}}-{{$moment(coupon.validEndDate).format("YYYY.MM.DD")}}</div>
                                </div>
                            </div>
                            <hr class="dashedHr1px" />
                            <div class="coupon_bottom">
                                <div class="couponRemark">使用说明：{{coupon.remark}}</div>
                                <div class="coupontip">
                                    <el-tooltip class="item" effect="dark" :content="coupon.remark" placement="top">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <hr class="dashedHr"  v-if="!isTeamShop"/>
            <div class="payPageDetail" v-if="!isTeamShop">
                <div>赠送金</div>
                <div>
                    <el-radio-group v-model="payInfo.couponType" @change="changeCoupon">
                        <el-radio :label="1" :disabled="payInfo.discountType == 2">
                            <span class="voucherName">个人赠送金</span>
                            <span class="balanceMoney">当前余额(¥{{moneyInfo.cashCouponBalance ? moneyInfo.cashCouponBalance.toFixed(2) : '0.00'}})</span>
                        </el-radio>
                        <el-radio :label="2" :disabled="payInfo.discountType == 1">
                            <span class="voucherName">团队赠送金</span>
                            <span class="balanceMoney">当前余额(¥{{teamInfo.cashCouponBalance ? teamInfo.cashCouponBalance.toFixed(2) : '0.00'}})</span>
                        </el-radio>
                    </el-radio-group>
                    <span style="margin-left: 50px">
                -
                <el-input-number
                  v-model="payInfo.cashCoupon"
                  :controls="false"
                  :min="0"
                  size="mini"
                  :precision="2"
                  style="width: 100px"
                  :max="payInfo.couponType == 1 ? moneyInfo.cashCouponBalance : payInfo.couponType == 2 ? teamInfo.cashCouponBalance : 0 "
                  @change="getMoney"
                ></el-input-number>
                <!-- <el-input
                    v-model="payInfo.cashCoupon"
                    :max="payInfo.couponType == 1 ? userInfo.cashCouponBalance :payInfo.couponType == 2 ? userInfo.cashTeamCouponBalance : 0 "
                    :min="0"
                     @blur="getMoney(payInfo)"
                    size="mini"
                    style="width: 100px"
                    clearable>
                    </el-input> -->
              </span>
                    <div class="tipsWord">使用团队赠送金则仅能使用团队信用或团队预存支付,使用个人赠送金则不能使用团队信用或团队预存支付</div>
                </div>
            </div>
            <hr class="dashedHr" v-if="!isTeamShop"/>
            <div class="payPageDetail">
                <div class="payTotalName">费用总计</div>
                <div class="redColor payTotalMoney">¥{{totalMoney || '0.00'}}</div>
            </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" style="margin-top: 20px" id="payWay">
            <div slot="header" class="clearfix">
                <div class="descicon"></div>支付方式
            </div>
            <div style="padding: 20px">
                <div class="wayName">预存支付</div>
                <el-radio-group v-model="payInfo.prepaidPayment" @change="changePayment">
                    <el-radio :label="1" :disabled="totalMoney > moneyInfo.depositAdvance">
                        <div class="payNameRow">
                            <div class="payImg">
                                <img src="../../assets/img/gryc.png" />
                            </div>
                            <div class="payName">个人预存</div>
                            <div class="balanceMoney" v-if="totalMoney > moneyInfo.depositAdvance">余额不足</div>
                            <div class="balanceMoney" v-else>当前余额 (¥{{moneyInfo.depositAdvance || 0.00}})</div>
                            <div>
                                <el-button type="text" size="mini" @click="applyPrestore">申请预存</el-button>
                            </div>
                        </div>
                    </el-radio>
                    <el-radio v-if="userInfo.teamId" :label="2" :disabled="Boolean((totalMoney > moneyInfo.depositAdvanceTeam) || !userInfo.teamId || (teamInfo.prestoreSwitch && (userInfo.characterRole == 3)))">
                        <div class="payNameRow">
                            <div class="payImg">
                                <img src="../../assets/img/tdyc.png" />
                            </div>
                            <div class="payName">团队预存</div>
                            <div class="balanceMoney" v-if="totalMoney > moneyInfo.depositAdvanceTeam">余额不足</div>
                            <div class="balanceMoney" v-else-if="teamInfo.prestoreSwitch && userInfo.characterRole == 3">团长已开启预存限制</div>
                            <div>
                                <el-button type="text" @click="applyPrestore" size="mini" v-if="userInfo.commanderFlag == 1">申请预存</el-button>
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
                <div class="wayName">其他方式</div>
                <el-radio-group v-model="payInfo.prepaidPayment" @change="changePayment">
                    <el-radio :label="3" v-if="[103].includes(userInfo.unitId)">
                        <div class="payNameRow">
                            <div class="payImg">
                                <img src="../../assets/img/zfb.png" />
                            </div>
                            <div class="payName">支付宝支付</div>
                            <div class="orangeColor">支付成功后如需退款请联系客服</div>
                        </div>
                    </el-radio>
                    <el-radio :label="4" v-if="[101, 103, 298].includes(userInfo.unitId)">
                        <div class="payNameRow">
                            <div class="payImg">
                                <img src="../../assets/img/wx.png" />
                            </div>
                            <div class="payName">微信支付</div>
                            <div class="orangeColor">支付成功后如需退款请联系客服</div>
                        </div>
                    </el-radio>
                    <el-radio :label="5" :disabled="totalMoney > moneyInfo.clientCreditBalance || userInfo.realNameStatus !== 1">
                        <div class="payNameRow">
                            <div class="payImg">
                                <img src="../../assets/img/grxy.png" />
                            </div>
                            <div class="payName">个人信用支付</div>
                            <div class="orangeColor" style="line-height: 20px;font-size: 12px" v-if="userInfo.certStatus != 1">您未进行身份认证，认证通过后可自动获得最高5000额度</div>
                            <el-button style="margin-left: 20px;" v-if="userInfo.certStatus != 1" type="text" size="mini" @click="goIdentityPage">前往身份认证</el-button>
                            <div class="balanceMoney" v-else-if="totalMoney > moneyInfo.clientCreditBalance">余额不足</div>
                            <div class="balanceMoney" v-else>当前余额 (¥{{moneyInfo.clientCreditBalance || 0.00}})</div>
                        </div>
                    </el-radio>
                    <el-radio v-if="userInfo.teamId" :label="6" :disabled="totalMoney > moneyInfo.teamCreditBalance || !userInfo.teamId || userInfo.certStatus != 1">
                        <div class="payNameRow">
                            <div class="payImg">
                                <img src="../../assets/img/tdxy.png" />
                            </div>
                            <div class="payName">团队信用支付</div>
                            <div class="balanceMoney" v-if="userInfo.certStatus != 1">暂未进行身份认证，进行身份认证后才可使用团队信用支付</div>
                            <el-button style="margin-left: 20px;" v-if="userInfo.certStatus != 1" type="text" size="mini" @click="goIdentityPage">前往身份认证</el-button>
                            <div class="balanceMoney" v-else-if="totalMoney > moneyInfo.teamCreditBalance">余额不足</div>
                        </div>
                    </el-radio>
                </el-radio-group>
            </div>
        </el-card>
    </div>
</template>

<script>
import { couponClient, myAssetsMoney, teamInfo } from "@/api/request";
import { getClient } from "@/plugins/auth";
export default {
    props: ['isTeamShop'],
    data() {
        return {
            couponList: [],
            equipInfo: {},
            totalMoney: 0,
            cashCoupon: 0,
            moneyInfo: {},
            wayList: [{ name: "个人预存" }],
            payInfo: {
                couponType: 1,
                cashCoupon: 0,
                couponMoney: 0,
                totalCost: 0,
                discountMoney: 0,
                discountType: undefined,
                prepaidPayment: undefined,
            },
            userInfo: JSON.parse(getClient()),
            teamInfo: {}
        }
    },
    methods: {
        async init(info, equipInfo) {
            if(this.userInfo.teamId) {
                const teamInfoRes = await teamInfo(this.userInfo.teamId)
                this.teamInfo = teamInfoRes.data
            }
            const res = await myAssetsMoney(this.userInfo.clientId)
            this.moneyInfo = res.data
            this.payInfo = { ...info, couponType: undefined, discountMoney: 0,paymentAudit: res.data.paymentAudit, discountType: undefined ,prepaidPayment: ''};
            // this.payInfo.prepaidPayment = 4
            this.equipInfo = equipInfo;
            //加急费用
            if (info.ifUrgent == 1) {
                this.payInfo.expeditedProduction = (
                    Number(info.originalPrice) * 0.5
                ).toFixed(2);
            }
            //运费
            if (info.postPayment == 1 && info.postMethod == 1) {
                this.payInfo.freightCollected = 12
            } else {
                this.payInfo.freightCollected = 0
            }
            //回收
            if (info.ifRecycle == 1) {
                if(this.$store.getters.userInfo.whiteFlag == 1){
                    if(this.$store.getters.userInfo.recoveryFree == 1){
                        this.payInfo.sampleRecovery = 0
                    }else{
                        this.payInfo.sampleRecovery = info.addressId == 298 ? 12 : 50
                    }
                }else{
                    this.payInfo.sampleRecovery = info.addressId == 298 ? 12 : 50
                }
                
            } else {
                this.payInfo.sampleRecovery = 0
            }
            if (info.ifUrgent == 0) {
                this.payInfo.expeditedProduction = 0;
            }
            this.getMoney()
            //订单折扣，如果有团队取团队比例，没有取个人(之前的逻辑)
            // let discountRate = this.userInfo.teamId ? this.moneyInfo.discountRateTeam : this.moneyInfo.discountRate
            // let discountRate = this.moneyInfo.discountRate
            // this.getDiscount(discountRate)
        },
        async getDiscount (discountRate) {
            const rate = (100 - Number(discountRate)) / 100
            this.payInfo.discountMoney = (Number(this.payInfo.originalPrice) * rate).toFixed(2)
            //计算优惠券门槛
            this.payInfo.totalDiscountMoney =  Number(this.payInfo.originalPrice) - Number(this.payInfo.discountMoney);
            this.payInfo.cashCoupon = 0;
            this.payInfo.couponMoney = 0;
            this.payInfo.couponRelevanceId = null;
            await this.getCouponList();
            this.$forceUpdate();
        },
        //申请预存
        applyPrestore() {
            this.$router.push({
                path: "/aboutUsIndex",
                query: { type: 13, tabIndex: '1-1', tabName: '我的资产' },
            });
        },
        getMoney() {
            // 费用总计分为两部分
            //可参与优惠计算的部分reducibleAmount--- 原价-订单折扣-优惠券-赠送金
            //不可参与优惠计算的部分notReducibleAmount 运费+回收+加急
            //优惠券
            //couponMoney --- 优惠券
            //cashCoupon --- 赠送金
            //discountMoney --- 订单折扣
            //freightCollected ---  到付运费
            //sampleRecovery ---  样品回收
            //expeditedProduction --- 加急制作
            const payInfo = JSON.parse(JSON.stringify(this.payInfo))
            let couponMoney = payInfo.couponMoney ? payInfo.couponMoney : 0;
            let cashCoupon = payInfo.cashCoupon ? payInfo.cashCoupon : 0;
            let reducibleAmount = Number(payInfo.originalPrice) - Number(payInfo.discountMoney || 0)
            let notReducibleAmount = Number(payInfo.freightCollected) + Number(payInfo.sampleRecovery) + Number(payInfo.expeditedProduction)
            if(reducibleAmount - couponMoney <= 0) {
                payInfo.cashCoupon = 0
                reducibleAmount = 0
            } else if(reducibleAmount - couponMoney - cashCoupon <= 0){
                payInfo.cashCoupon = Number((reducibleAmount - couponMoney).toFixed(2))
                cashCoupon = Number((reducibleAmount - couponMoney).toFixed(2))
                reducibleAmount = 0
                if(payInfo.freightCollected || payInfo.sampleRecovery || payInfo.expeditedProduction) {
                    this.$message.warning('赠送金或优惠券不能抵扣加急费用、运费、回收费用')
                }
            } else {
                reducibleAmount = Number((reducibleAmount - couponMoney - cashCoupon).toFixed(2))
                payInfo.cashCoupon = cashCoupon
            }
            let totalCost = reducibleAmount + notReducibleAmount
            totalCost = Number(totalCost).toFixed(2)
            // 0 元订单仍需允许用户确认支付，由提交页跳过第三方支付并直接完成订单。
            this.$emit('changeButtonStatus', false)
            this.totalMoney = totalCost
            let obj = { ...payInfo, totalCost, couponMoney, cashCoupon }
            this.$forceUpdate()
            this.$nextTick(() => {
                this.payInfo = payInfo
                this.$emit("getTotalCost", obj)
            })
        },
        cleanUp(){
            this.couponList.forEach(item => item.checked = false)
            this.payInfo.couponMoney = 0
            this.payInfo.cashCoupon = undefined
            this.$forceUpdate(); // 如果 Vue.set 不能解决问题，可以尝试强制更新
        },
        changeCoupon() {
            this.payInfo.cashCoupon = 0;
            this.getMoney();
        },
       changePayment(e){
            this.payInfo.prepaidPayment = e
            if(this.isTeamShop) {
                this.getMoney()
                return
            }
            if(e === 1 || e === 3 || e === 4 || e === 5){
                this.payInfo.discountType = 1
            }else {
                this.payInfo.discountType = 2
            }
            this.changeDiscount(this.payInfo.discountType)
        },
        //隐藏不合条件的优惠券
        showCoupon(paymentType) {
            let list = []
            const paymentType_list = paymentType.split(',')
            paymentType_list.forEach(item => {
                switch(item) {
                    case '预存支付':
                        list = [...list, 1, 2]
                        break
                    case '现金支付':
                        list = [...list, 3, 4]
                        break
                    case '信用支付':
                        list = [...list, 5, 6]
                        break
                }
            })
            const result = list.includes(this.payInfo.prepaidPayment)
            return result
        },
        changeDiscount (val) {
            this.payInfo.couponType = this.payInfo.discountType
            let discountRate = val == 2 ? this.moneyInfo.discountRateTeam : this.moneyInfo.discountRate
            this.getDiscount(discountRate)
            this.changeCoupon()
        },
        async getCouponList() {
            let business = 0
            if (this.payInfo.discountType == 1) {
                business = this.userInfo.clientId
            } 
            if (this.payInfo.discountType == 2) {
                business = this.userInfo.teamId ? this.userInfo.teamId : 0
            }
            const res = await couponClient({
                issueStatus: 2,
                business: this.userInfo.clientId,
                pageSize: 1000,
                equipmentId: this.payInfo.equipmentId,
                businessType: 1,
                business: business,
                serviceThreshold: this.payInfo.totalDiscountMoney || 0,
            })
            if(this.payInfo.equipmentId !== 87){
                this.couponList = res.rows.map(item => {
                    item.checked = false
                    return item
                })
            }else{
                if(res.rows){
                    let list = res.rows.filter(item => item.couponId === 38)
                    this.couponList = list
                }else{
                    this.couponList = []
                }
            }
            this.$forceUpdate();
        },
        changeCheck(coupon, index) {
            this.couponList.forEach(i => {
                if (i.id != coupon.id) {
                    i.checked = false;
                }
            });
            //重置支付方式、折扣比例、折扣金额
            const prepaidPayment = this.payInfo.prepaidPayment //支付方式---判断是个人/团队折扣
            let discountRate = this.moneyInfo.discountRate //折扣比例
            if(prepaidPayment === 1 || prepaidPayment === 3 || prepaidPayment === 4 || prepaidPayment === 5){
                this.payInfo.discountType = 1
            } else if(prepaidPayment == 2 || prepaidPayment == 6) {
				this.payInfo.discountType = 2
				discountRate = this.moneyInfo.discountRateTeam
			} else {
				this.payInfo.couponMoney = 0
				this.payInfo.couponRelevanceId = null
				return
			}
            const rate = (100 - Number(discountRate)) / 100 //折扣比例
            this.payInfo.discountMoney = (Number(this.payInfo.originalPrice) * rate).toFixed(2)
            //计算优惠券金额
            const list = this.couponList.filter(i => {
                return i.checked;
            });
            if (list.length > 0) {
                if(coupon.clientDiscount == 1) {
                    this.payInfo.discountType = undefined
                    this.payInfo.discountMoney = undefined 
                }
                this.payInfo.couponRelevanceId = coupon.id
                if(coupon.couponMode == 1) {
                    this.payInfo.couponMoney = coupon.deductionAmount || 0
                }
                if(coupon.couponMode == 2) {
                    const price = Number(this.payInfo.originalPrice) - Number(this.payInfo.discountMoney || 0)
                    const rate = (100 - coupon.couponRate) / 100
                    this.payInfo.couponMoney = Math.ceil(price * rate)
                }
            } else {
                this.payInfo.couponMoney = 0;
                this.payInfo.couponRelevanceId = null;
            }
            this.getMoney();
            this.$forceUpdate();
        },
        //前往身份认证
        goIdentityPage() {
            this.$router.push({
                path: '/aboutUsIndex',
                query: { 
                    tabIndex: '1-3', 
                }
            });
        },
    }
};
</script>
<style>
.pay_coupon_name .el-tag {
    height: 18px;
    padding: 0 3px;
    line-height: 18px;
    margin-top: 5px;
    margin-right: 5px;
    font-size: 10px;
}
</style>
<style>
#paypage .el-card__body {
    padding: 0 20px;
}

#payWay .el-radio {
    display: flex;
    line-height: 50px;
}

#payWay .el-radio__input {
    line-height: 50px;
}
</style>

<style scoped lang="scss">
.zhekouClass {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 68%;
    min-width: 540px;
}
.emptycoupon {
    width: 100%;
    height: 50px;
    line-height: 50px;
    color: #999;
    text-align: center;
}
.balanceMoney {
    font-size: 12px;
    color: #666;
    font-weight: 400;
    margin-right: 15px
}

.payImg {
    width: 30px;
    height: 30px;
    img {
        width: 100%
    }
}

.payNameRow {
    height: 50px;
    line-height: 50px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

.payName {
    font-size: 16px;
    color: #111;
    margin-right: 20px;
    margin-left: 10px;
    font-weight: 400;
}

.wayName {
    line-height: 35px;
    font-size: 20px;
}

.voucherName {
    color: #666;
    margin-right: 10px;
}

.payPageDetail {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: 20px 0;
}

.payTotalName {
    font-size: 16px;
    font-weight: 500;
}

.payTotalMoney {
    font-size: 30px;
}

.couponList {
    max-height: 260px;
    overflow: hidden;
    overflow-y: scroll;
    border-top: 1px solid #e8e8e8;
    padding: 20px 30px;
}

.coupon_box {
    background: #fffbf4;
    border-radius: 5px;
    margin-bottom: 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.07);
    position: relative;
}

.coupon_line {
    width: 1px;
    height: 100%;
    background: #eb5d39;
    border-radius: 5px 0px 0px 0px;
}

.coupon_box_content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    border-left: 3px solid #eb5d39;
}

.pay_coupon_name {
    width: 50%;
}
.couponName-left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.couponRemark {
    color: #c8c8c8;
    font-size: 12px;
    width: 95%;
    -webkit-line-clamp: 1;
    white-space: nowrap;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.couponAmount {
    font-size: 24px;
    color: #eb5d39;
}

.serviceThreshold {
    font-size: 12px;
    color: #e28972;
}

.coupon_amount {
    width: 25%;
    text-align: center;
    margin: 20px;
    padding-right: 20px;
    border-right: 1px dashed #e8e8e8;
}

.couponName {
    font-size: 18px;
    color: #111;
    font-weight: 500;
    margin-top: 5px;
}

.couponTime {
    color: #999;
    font-size: 12px;
    margin-top: 10px;
}

.coupon_bottom {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 5px 10px;
}

.coupontip {
    color: #c8c8c8;
    font-size: 16px;
    cursor: pointer;
}

.desc-check {
    position: absolute;
}
</style>